import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function InviteHandler() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      console.log('📧 Processing invite token:', token);
      localStorage.setItem('inviteToken', token);
      navigate('/auth?invite=' + token);
    }
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Processing your invitation...</p>
      </div>
    </div>
  );
}